import s, { memo as a } from "react";
import { useStyleConfig as r, Box as l, Link as m } from "@chakra-ui/react";
const u = a((t) => {
  const { variant: e, size: n, ...i } = t, o = r("Button", {
    variant: e,
    size: n
  });
  return /* @__PURE__ */ s.createElement(
    l,
    {
      as: m,
      "data-testid": "button-link",
      display: "inline-flex",
      alignItems: "center",
      __css: o,
      ...i
    }
  );
});
u.displayName = "ButtonLink";
export {
  u as ButtonLink
};
